module.exports = __webpack_public_path__ + "static/media/8.bd2aec5b.png";